/**
 * Abort a hung / incomplete post-redirect finalize without IdP logoutRedirect.
 * Lets the user re-attempt email/SSO on #/login (DE-9405).
 * Explicit "Return to login" may still call full userActions.logout().
 */
import config from "config";

import { userConstants } from "../constants";
import { clearAbandonedInteractiveAuth } from "./authRedirectPending";
import { clearAuthRelatedSessionStorage } from "./postAuthGrace";

export const softReturnToLogin = (dispatch) => {
  clearAbandonedInteractiveAuth();
  clearAuthRelatedSessionStorage();
  try {
    localStorage.removeItem(
      `ads.auth.token.key${config.adsMsalConfig.clientID}`,
    );
  } catch (_e) {
    // ignore
  }
  if (typeof dispatch === "function") {
    // Clears email/msal logging-in flags without setting loggingOut (unlike LOGOUT).
    dispatch({ type: userConstants.EMAIL_LOGIN_FAILURE });
  }
  try {
    window.location.hash = "#/login";
  } catch (_e) {
    // ignore
  }
};
